import React, { Component } from 'react';
import './style.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from "react-bootstrap";

class MyCertificates extends Component {

    static contextTypes = { api: PropTypes.object };

    render() {

        return (
            <div>
                {this.props.me && this.props.me.person && this.props.me.person.membership && this.props.me.person.membership.annuityPayments && this.props.me.person.emittedCertificates.length ?
                    <Table>
                        <tbody>
                            {this.props.me.person.emittedCertificates.map((emittedCertificate, index) =>
                                <tr key={emittedCertificate.id}>
                                    <td>{emittedCertificate.certificate.name}</td>
                                    <td><a href={this.context.api.appFiles.getDownloadUrl(emittedCertificate.file.id)} rel='noopener'><button className='btn btn-default'>Descargar</button></a></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    :
                    <p>Ninguna constancia registrada</p>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ api: { me = {} } }) => ({ me });

export default connect(mapStateToProps)(MyCertificates);



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MyCertifciates/index.jsx